import React from 'react';
import styles from './PrimaryButton.module.css';

interface PrimaryButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

/**
 * 큰 터치 버튼 (최소 높이 72px, 전체 너비)
 */
export function PrimaryButton({ onClick, disabled = false, children }: PrimaryButtonProps) {
  return (
    <button
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {children}
    </button>
  );
}
